import { render, staticRenderFns } from "./VCurrencyRecord.vue?vue&type=template&id=012b994f&scoped=true&"
import script from "./VCurrencyRecord.vue?vue&type=script&lang=js&"
export * from "./VCurrencyRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012b994f",
  null
  
)

export default component.exports